<div [formGroup]="form">
  <div class="section-container" id="info-basica">
    <div class="section-title">
      <mat-icon>info</mat-icon>
      <span>Dados Gerais</span>
    </div>

    <div class="row">
      <div class="col-12 col-md-3">
        @if (listaTipoProduto) {
          <app-select-pesquisavel
            label="Tipo de Produto"
            [offlineList]="listaTipoProduto"
            [control]="idTipoProdutoControl"
            idField="id"
            nameField="descricao"
            placeholder="Selecione..."
            (selectionChange)="onTipoProdutoChange($event)">
          </app-select-pesquisavel>
        }
      </div>
      <div class="col-12 col-md-3">
        @if (listaTipoItemSped) {
          <app-select-pesquisavel
            label="Tipo de Item SPED"
            [offlineList]="listaTipoItemSped"
            [control]="idTipoItemSpedControl"
            idField="id"
            nameField="descricao"
            placeholder="Selecione...">
          </app-select-pesquisavel>
        }
      </div>
      <div class="col-12 col-md-3 d-flex align-items-center">
        <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivo">Ativo</mat-slide-toggle>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nome do Produto</mat-label>
          <input matInput formControlName="nome" placeholder="Ex: Camiseta Básica" maxlength="120" />
          <mat-hint align="end">{{ form.get('nome')?.value?.length || 0 }} / 120</mat-hint>
          @if (form.get('nome')?.hasError('required')) {
            <mat-error>Campo obrigatório</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>SKU</mat-label>
          <input matInput formControlName="codigoSku" placeholder="Código Interno"
            [matTooltip]="form.get('codigoSku')?.disabled
              ? 'Código automático. Este campo está desativado porque o sistema gera o SKU automaticamente. Se quiser digitar manualmente, altere as configurações de cadastro de produto.'
              : ''" />
          @if (form.get('codigoSku')?.hasError('required')) {
            <mat-error>Informe o SKU</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>GTIN/EAN</mat-label>
          <input matInput formControlName="gtinEan" [mask]="masks.gtinEan" placeholder="Código de Barras" />
          <button mat-icon-button matSuffix type="button" class="btn-spinner" [class.btn-loading]="isBuscandoGtin"
            matTooltip="Buscar dados pelo GTIN" aria-label="Buscar dados pelo GTIN" (click)="onBuscarGtin()"
            [disabled]="isBuscandoGtin">
            <mat-icon>search</mat-icon>
            @if (isBuscandoGtin) { <mat-spinner diameter="20"></mat-spinner> }
          </button>
          @if (form.get('gtinEan')?.hasError('required')) {
            <mat-error>Informe o GTIN/EAN</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-4">
        @if (listaUnidadeMedida) {
          <app-select-pesquisavel
            label="Unidade de Medida"
            [offlineList]="listaUnidadeMedida"
            [control]="idUnidadeMedidaControl"
            idField="idUnidadeMedida"
            nameField="descricao"
            placeholder="Selecione...">
          </app-select-pesquisavel>
        }
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>NCM</mat-label>
          <input matInput type="text" inputmode="numeric"
            [formControl]="ncmControl"
            [mask]="masks.ncm"
            placeholder="Ex: 0101.21.00"
            (keydown)="onCodigoKeydown($event)" />
          <button mat-icon-button matSuffix type="button"
            matTooltip="Pesquisar NCM"
            (click)="pesquisarNcm()">
            <mat-icon>search</mat-icon>
          </button>
          @if (ncmControl?.touched && ncmControl?.hasError('required')) {
            <mat-error>Informe o NCM.</mat-error>
          } @else if (ncmControl?.touched && ncmControl?.hasError('ncmSubitem')) {
            <mat-error>O NCM deve ter 8 dígitos (subitem).</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        @if (listaOrigem) {
          <app-select-pesquisavel
            label="Origem"
            [offlineList]="listaOrigem"
            [control]="idOrigemMercadoriaControl"
            idField="id"
            nameField="descricao"
            placeholder="Selecione...">
          </app-select-pesquisavel>
        }
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>CEST</mat-label>
          <input matInput type="text" inputmode="numeric"
            [formControl]="cestControl"
            [mask]="masks.cest"
            placeholder="Ex: 01.001.00"
            (keydown)="onCodigoKeydown($event)" />
          <button mat-icon-button matSuffix type="button"
            matTooltip="Pesquisar CEST"
            (click)="pesquisarCest()">
            <mat-icon>search</mat-icon>
          </button>
          @if (cestControl?.touched && cestControl?.hasError('required')) {
            <mat-error>Informe o CEST</mat-error>
          } @else if (cestControl?.touched && cestControl?.hasError('cestCompleto')) {
            <mat-error>O CEST deve ter 7 dígitos.</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <h4 class="subsection-title">Dimensões e Peso</h4>
    <div class="row">
      <div class="col-6 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Peso Liq. (kg)</mat-label>
          <input matInput formControlName="pesoLiquidoKg" [currencyMask]="percentageMask" />
          @if (form.get('pesoLiquidoKg')?.hasError('required')) {
            <mat-error>Informe o peso líquido</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-6 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Peso Bruto (kg)</mat-label>
          <input matInput formControlName="pesoBrutoKg" [currencyMask]="percentageMask" />
          @if (form.get('pesoBrutoKg')?.hasError('required')) {
            <mat-error>Informe o peso bruto</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-6 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Volumes</mat-label>
          <input matInput formControlName="volumes" [currencyMask]="integerMask" />
        </mat-form-field>
      </div>
      <div class="col-6 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Largura (cm)</mat-label>
          <input matInput formControlName="larguraCm" [currencyMask]="percentageMask" />
        </mat-form-field>
      </div>
      <div class="col-6 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Altura (cm)</mat-label>
          <input matInput formControlName="alturaCm" [currencyMask]="percentageMask" />
        </mat-form-field>
      </div>
      <div class="col-6 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Comprimento (cm)</mat-label>
          <input matInput formControlName="comprimentoCm" [currencyMask]="percentageMask" />
        </mat-form-field>
      </div>
      <div class="col-6 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Diâmetro (cm)</mat-label>
          <input matInput formControlName="diametroCm" [currencyMask]="percentageMask" />
        </mat-form-field>
      </div>

      <div class="col-12 col-md-4">
        @if (listaEmbalagem) {
          <app-select-pesquisavel
            label="Embalagem"
            [offlineList]="listaEmbalagem"
            [control]="idEmbalagemControl"
            idField="idEmbalagem"
            nameField="descricao"
            [isOptional]="true">
          </app-select-pesquisavel>
        }
      </div>
    </div>
  </div>
</div>
